import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { CCInfo } from '@library-shared/models/cc-info';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { spTicket_List_Selected } from '@models/StoredProcs/spTicket_List_Selected';
import { PaymentService } from '@services/payment/payment.service';
import { SiteService } from '@services/site/site.service';
import { TicketService } from '@services/ticket/ticket.service';
import { CreditCardInformationComponent } from './widgets/credit-card-information/credit-card-information.component';

@Component({
  selector: 'app-pay-ticket',
  templateUrl: './pay-ticket.component.html',
  styleUrls: ['./pay-ticket.component.scss'],
  standalone: false,
})
export class PayTicketComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('creditCardPanel')
  creditCardPanel: CreditCardInformationComponent;
  ccInfo = new CCInfo();
  site = new spSite_Client_By_DomainX();

  balanceToPay = 0;
  conveniencePay = 0;
  paymentAmount = 0;
  processingFee = 0;
  totalWithFee = 0;
  feeReady = false;

  ticketList: spTicket_List_Selected[] = [];

  get motoristList(): string {
    const arList = this.ticketList.filter((r) => r.license_number).map((r) => r.license_number + ' ' + r.license_state);

    const seListNoDupe = new Set(arList);
    const arListNoDupe = [...seListNoDupe];
    return arListNoDupe.join(', ');
  }

  get plateList(): string {
    const arList = this.ticketList
      .filter((r) => r.plate_number && !r.license_number)
      .map((r) => r.plate_number + ' ' + r.plate_state);

    const seListNoDupe = new Set(arList);
    const arListNoDupe = [...seListNoDupe];
    return arListNoDupe.join(', ');
  }

  constructor(
    private siteService: SiteService,
    private ticketService: TicketService,
    private paymentService: PaymentService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading2.set(true);
    this.siteService.Site_Info().subscribe({
      next: (data) => {
        this.site = data.record;
        this.ticketService.Ticket_List_Selected().subscribe({
          next: (data2) => {
            /*
                        if (!ccsetup) {
                            ccsetup = this.site.Site_CC_Info_List.find((r) => r.ticket_type === 'A' && !r.card_present);
                        }
                        */
            this.ticketList = data2.records;
            if (this.ticketList.length == 0) {
              this.router.navigateByUrl('/search');
              return;
            }

            this.refreshTicketData();
            this.calculateProcessingFee(() => {
              this.creditCardPanel?.onCCChange();
              this.isLoading2.set(false);
            });
          },
        });
      },
    });
  }

  onTicketsLoaded(tickets: spTicket_List_Selected[]) {
    this.ticketList = tickets;
    this.refreshTicketData();
    this.calculateProcessingFee();
  }

  refreshTicketData() {
    this.ccInfo.payment_amount = 0;
    this.ticketList.forEach((r) => (this.ccInfo.payment_amount += r.ticket_balance));
  }

  calculateProcessingFee(onComplete?: () => void) {
    this.feeReady = false;
    this.paymentService
      .Payment_CalculateProcessingFee(this.ccInfo.payment_amount, [])
      .subscribe({
        next: (data) => {
          if (data.success && data.record) {
            this.processingFee = data.record.total_processing_fee ?? 0;
            this.totalWithFee = data.record.total_with_fee ?? this.ccInfo.payment_amount;
            this.feeReady = true;
          } else {
            this.processingFee = 0;
            this.totalWithFee = this.ccInfo.payment_amount;
            this.feeReady = false;
            this.toast_error({ message: data.message || 'Unable to calculate processing fee.' });
          }
          onComplete?.();
        },
        error: () => {
          this.processingFee = 0;
          this.totalWithFee = this.ccInfo.payment_amount;
          this.feeReady = false;
          onComplete?.();
        },
      });
  }
}
